import { render, staticRenderFns } from "./BillDetailsForm.vue?vue&type=template&id=6df6bf56&scoped=true"
import script from "./BillDetailsForm.vue?vue&type=script&lang=js"
export * from "./BillDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df6bf56",
  null
  
)

export default component.exports